import React from 'react'
import { FiSearch } from 'react-icons/fi'

function addCashReconciliation(props) {
    const { userDataFromStorage, coloredTheme } = props
    return (
        <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
            <p className='text-gray-800 text-[1.8rem] tracking-wider'>Cash +/-</p>
            
        </div>
    )
}

export default addCashReconciliation